export const GET_ALL_REPORT_SUBSCRIPTION_REQUEST =
  'GET_ALL_REPORT_SUBSCRIPTION_REQUEST';
export const GET_ALL_REPORT_SUBSCRIPTION_SUCCESS =
  'GET_ALL_REPORT_SUBSCRIPTION_SUCCESS';
export const GET_ALL_REPORT_SUBSCRIPTION_ERROR =
  'GET_ALL_REPORT_SUBSCRIPTION_ERROR';

export const GET_REPORT_SUBSCRIPTION_DETAIL_REQUEST =
  'GET_REPORT_SUBSCRIPTION_DETAIL_REQUEST';
export const GET_REPORT_SUBSCRIPTION_DETAIL_SUCCESS =
  'GET_REPORT_SUBSCRIPTION_DETAIL_SUCCESS';
export const GET_REPORT_SUBSCRIPTION_DETAIL_ERROR =
  'GET_REPORT_SUBSCRIPTION_DETAIL_ERROR';

export const GET_REPORT_SUBSCRIPTION_LOGS_REQUEST =
  'GET_REPORT_SUBSCRIPTION_LOGS_REQUEST';
export const GET_REPORT_SUBSCRIPTION_LOGS_SUCCESS =
  'GET_REPORT_SUBSCRIPTION_LOGS_SUCCESS';
export const GET_REPORT_SUBSCRIPTION_LOGS_ERROR =
  'GET_REPORT_SUBSCRIPTION_LOGS_ERROR';

export const DELETE_REPORT_SUBSCRIPTION_REQUEST =
  'DELETE_REPORT_SUBSCRIPTION_REQUEST';
export const DELETE_REPORT_SUBSCRIPTION_SUCCESS =
  'DELETE_REPORT_SUBSCRIPTION_SUCCESS';
export const DELETE_REPORT_SUBSCRIPTION_ERROR =
  'DELETE_REPORT_SUBSCRIPTION_ERROR';

export const CANCEL_REPORT_SUBSCRIPTION_INSTANCE_REQUEST =
  'CANCEL_REPORT_SUBSCRIPTION_INSTANCE_REQUEST';
export const CANCEL_REPORT_SUBSCRIPTION_INSTANCE_SUCCESS =
  'CANCEL_REPORT_SUBSCRIPTION_INSTANCE_SUCCESS';
export const CANCEL_REPORT_SUBSCRIPTION_INSTANCE_ERROR =
  'CANCEL_REPORT_SUBSCRIPTION_INSTANCE_ERROR';

export const TOGGLE_DIALOG = 'TOGGLE_DIALOG';
export const GET_YESTERDAY_MACHINES_SHIFTS_REQUEST =
  'GET_YESTERDAY_MACHINES_SHIFTS_REQUEST';
export const GET_YESTERDAY_MACHINES_SHIFTS_SUCCESS =
  'GET_YESTERDAY_MACHINES_SHIFTS_SUCCESS';
export const GET_YESTERDAY_MACHINES_SHIFTS_ERROR =
  'GET_YESTERDAY_MACHINES_SHIFTS_ERROR';
export const GET_REPORT_DASHBOARDS_REQUEST = 'GET_REPORT_DASHBOARDS_REQUEST';
export const GET_REPORT_DASHBOARDS_SUCCESS = 'GET_REPORT_DASHBOARDS_SUCCESS';
export const GET_REPORT_DASHBOARDS_ERROR = 'GET_REPORT_DASHBOARDS_ERROR';
export const GET_REPORT_GROUPED_DASHBOARDS_REQUEST =
  'GET_REPORT_GROUPED_DASHBOARDS_REQUEST';
export const GET_REPORT_GROUPED_DASHBOARDS_SUCCESS =
  'GET_REPORT_GROUPED_DASHBOARDS_SUCCESS';
export const GET_REPORT_GROUPED_DASHBOARDS_ERROR =
  'GET_REPORT_GROUPED_DASHBOARDS_ERROR';
export const MODIFY_CREATE_REPORT_DATA = 'MODIFY_CREATE_REPORT_DATA';
export const RESET_CREATE_REPORT_DATA = 'RESET_CREATE_REPORT_DATA';
export const CREATE_REPORT_SUBSCRIPTION_REQUEST =
  'CREATE_REPORT_SUBSCRIPTION_REQUEST';
export const CREATE_REPORT_SUBSCRIPTION_SUCCESS =
  'CREATE_REPORT_SUBSCRIPTION_SUCCESS';
export const CREATE_REPORT_SUBSCRIPTION_ERROR =
  'CREATE_REPORT_SUBSCRIPTION_ERROR';
export const UPDATE_REPORT_SUBSCRIPTION_REQUEST =
  'UPDATE_REPORT_SUBSCRIPTION_REQUEST';
export const UPDATE_REPORT_SUBSCRIPTION_SUCCESS =
  'UPDATE_REPORT_SUBSCRIPTION_SUCCESS';
export const UPDATE_REPORT_SUBSCRIPTION_ERROR =
  'UPDATE_REPORT_SUBSCRIPTION_ERROR';

export const CLEAR_REPORT_SUBSCRIPTION_DETAIL =
  'CLEAR_REPORT_SUBSCRIPTION_DETAIL';

export const SEND_REPORT_TO_RECIPIENTS_REQUEST =
  'SEND_REPORT_TO_RECIPIENTS_REQUEST';
export const SEND_REPORT_TO_RECIPIENTS_SUCCESS =
  'SEND_REPORT_TO_RECIPIENTS_SUCCESS';
export const SEND_REPORT_TO_RECIPIENTS_ERROR =
  'SEND_REPORT_TO_RECIPIENTS_ERROR';
export const REORDER_SUBSCRIPTION_DASHBOARDS_REQUEST =
  'REORDER_SUBSCRIPTION_DASHBOARDS_REQUEST';
export const REORDER_SUBSCRIPTION_DASHBOARDS_SUCCESS =
  'REORDER_SUBSCRIPTION_DASHBOARDS_SUCCESS';
export const REORDER_SUBSCRIPTION_DASHBOARDS_ERROR =
  'REORDER_SUBSCRIPTION_DASHBOARDS_ERROR';
